import React from 'react';
import OverImage from './OverImage';
import TwoColumn from './TwoColumn';

function ScrollableContent({ layout, ...others }) {
  if (layout === 'over image') return <OverImage {...others} />;

  return (
    <TwoColumn
      layout={layout}
      {...others}
    />
  );
}

export default ScrollableContent;
